import {keyframes} from 'stitches/config'

export const fadeInUp = keyframes({
    '0%': {
        display: 'none',
        opacity: 0,
    },
    '1%': {
        display: 'none',
        opacity: 0,
        transform: 'translate3d(0,50px,0)',
    },
    'to': {
        opacity: 1,
        transform: 'translate3d(0,0,0)',
    },
})
